import {
    Grid2,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Checkbox,
} from '@mui/material';
import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SkeletonTable from '../../../components/atom/SkeletonTable';
import { useCapabilities } from '../../../hooks/useCapabilities';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import { MODAL_TYPE, useModals } from '../../../hooks/useModal';

const SeatsTable = ({
    rows,
    loading,
    editedId,
    setEdited,
    deleteSeat,
    updateNameI18n,
    venueId,
}) => {
    const { t } = useTranslation();
    const { can, CAPABILITIES } = useCapabilities();
    const { showModal } = useModals();

    const canManageShows = can(CAPABILITIES.SHOWS_MANAGE);

    const renderActions = (row) =>
        canManageShows && (
            <>
                <Tooltip title={t('common.translations')}>
                    <IconButton
                        onClick={() => {
                            showModal(MODAL_TYPE.TRANSLATIONS, {
                                translations: row.nameI18n,
                                setTranslations: (translations) =>
                                    updateNameI18n(row.id, translations),
                                item: 'seats',
                                column: 'name',
                                venueId: venueId,
                                originalString: row.name,
                            });
                        }}
                    >
                        <LanguageIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('common.edit')}>
                    <IconButton onClick={() => setEdited(row.id)}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('common.delete')}>
                    <IconButton onClick={() => deleteSeat(row.id)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </>
        );

    const renderRow = (row) => (
        <TableRow key={row.id}>
            <TableCell>
                <Checkbox checked={row.bookable === true} disabled />
            </TableCell>
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.x}</TableCell>
            <TableCell>{row.y}</TableCell>
            <TableCell>{row.rotation}</TableCell>
            <TableCell>{row.scale}</TableCell>
            <TableCell>{row.model}</TableCell>
            <TableCell align="right">{renderActions(row)}</TableCell>
        </TableRow>
    );

    return (
        <Grid2 size={{ xs: 12 }}>
            <TableContainer>
                <Table sx={{ minWidth: 640 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('seats.columns.bookable')}</TableCell>
                            <TableCell>{t('seats.columns.name')}</TableCell>
                            <TableCell>{t('seats.columns.x')}</TableCell>
                            <TableCell>{t('seats.columns.y')}</TableCell>
                            <TableCell>{t('seats.columns.rotation')}</TableCell>
                            <TableCell>{t('seats.columns.scale')}</TableCell>
                            <TableCell>{t('seats.columns.model')}</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {editedId !== null &&
                            rows?.filter((row) => row.id === editedId).map(renderRow)}
                        {loading ? (
                            <SkeletonTable rows={4} cells={4} />
                        ) : (
                            rows?.filter((row) => row.id !== editedId).map(renderRow)
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid2>
    );
};

export default React.memo(SeatsTable);
